import { EmailTemplateSection } from './EmailTemplateSection'

const EmailTemplates = () => {
  return (
    <>
      <EmailTemplateSection
        fetchUrl="/v1/email/templates/followup"
        title="Follow-up Email Templates"
        type="followup"
        description="These email templates are used on your Pipeline Board (or Deals), when you select opportunities you want to follow-up on and click ‘Follow-up by Email’. Visit the Help Center to watch a video tutorial."
      />
      <EmailTemplateSection
        fetchUrl="/v1/email/templates/contacts"
        title="Contact Email Templates"
        type="contact"
        description="These email templates are used from a Contact Profile page, when you click on the ‘Email’ Contact icon. Visit the Help Center to watch a video tutorial."
      />
      <EmailTemplateSection
        fetchUrl="/v1/email/templates/sendproposal"
        title="Send Proposal Email Template"
        type="proposal"
        hideCreateBtn
        description="This email template is used when you send a proposal. When you edit this template, please be careful to not delete the proposal link."
      />
      <EmailTemplateSection
        fetchUrl="/v1/email"
        title="Single Lead Email Templates"
        type="leads"
        description="These email templates are used from a Lead page, when you click on the ‘Email’ Lead button."
      />
      <EmailTemplateSection
        fetchUrl="/v1/email/templates/bulk"
        title="Leads Email Templates"
        type="leads"
        description="These email templates are used from Leads page, when you click on the ‘Email Selected Leads’ button."
        isBulk
      />
    </>
  )
}

export default EmailTemplates
